export default __webpack_public_path__ + "static/media/primeroedge-feature.024ce9ff.png";